import axiosInstance from "../../core/axiosConfig.ts";

export default class CategoryService {
    async createCategory(payload: any) {
        const response = await axiosInstance.post(
            '/category/create',
            payload
        );
        return response.data;
    }
    async deleteCategory(categoryId: number) {
        const response = await axiosInstance.delete(
            '/category/delete', {params : {categoryId}}
        );
    }
    
}